import ArwenLogo from '../assets/brand/arwen-logo-red-medium.png'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { referrerState } from '../store/DomainStore'
import { useEffect, useMemo, useRef } from 'react'
import { useSearchAccountsQuery } from '../api/client'
import { useAuth } from '../auth/AuthContext'

export function GuidedOnboardingLayout({ isAuthenticated }: { isAuthenticated?: boolean }) {
    const [referrer] = useRecoilState(referrerState)
    const scrollContainerRef = useRef<HTMLDivElement>(null)

    const { pathname } = useLocation()

    useEffect(() => {
        if (scrollContainerRef.current && scrollContainerRef.current.scrollTop > 0) {
            scrollContainerRef.current.scrollTo({ top: 0 })
        }
    }, [pathname])

    const { data: accountsData } = useSearchAccountsQuery({
        skip: !isAuthenticated,
        variables: {
            params: {
                offset: 0,
                limit: 10,
                socialMediaServices: [],
                teamIds: [],
                keyword: ''
            }
        },
        onError: (error: any) => {
            throw Error(error.message)
        }
    })

    const connectedAccounts = useMemo(() => {
        if (!isAuthenticated || !accountsData) return undefined
        const accounts = accountsData.searchAccounts?.accounts || []
        const countMap = new Map<number, number>()
        for (const account of accounts) {
            const serviceId = account.socialMediaServiceId
            countMap.set(serviceId, (countMap.get(serviceId) || 0) + 1)
        }
        return countMap
    }, [isAuthenticated, accountsData])

    const shouldRedirect = pathname === '/' && !!connectedAccounts && !connectedAccounts?.size

    const { signOut } = useAuth()

    if (shouldRedirect) {
        return <Navigate to="/connect" replace />
    }

    // A hack to disable the guided onboarding layout on the homepage until we make the dashboard
    return pathname === '/' && isAuthenticated ? (
        <Outlet context={{ connectedAccounts }} />
    ) : (
        <div ref={scrollContainerRef} className="bg-gray-50 h-screen">
            <header className="sticky top-0 left-0 right-0 z-50 bg-white border-b border-border">
                <div className="container mx-auto px-4 py-4 flex items-center justify-between max-w-4xl">
                    <img src={referrer?.logoUrl!} alt="ATP Tour" className="h-8 md:h-10" />
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-muted-foreground font-medium">
                            Powered by
                        </span>
                        <img src={ArwenLogo} alt="Arwen" className="h-6 md:h-8" />
                    </div>
                </div>
            </header>

            <div className="p-4 md:p-10">
                <Outlet context={{ connectedAccounts }} />
            </div>
            {isAuthenticated && (
                <div className="mb-4 md:mb-10 flex items-center justify-center">
                    <div onClick={signOut} className=" text-primary cursor-pointer p-4 md:p-0">
                        Sign out
                    </div>
                </div>
            )}
        </div>
    )
}
